module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/app_manager/modal/client-detail/top/registration/registrationDsd/modal-client-detail-registration-dsd.component.css
// module id = ./src/app/app_manager/modal/client-detail/top/registration/registrationDsd/modal-client-detail-registration-dsd.component.css
// module chunks = main